<template>
  <div>
    <!-- pc 轮播 -->
    <template v-if="$screen.md">
      <b-carousel
        v-if="indexData && indexData.banners"
        id="carousel-1"
        ref="myCarousel"
        v-model="slide"
        :interval="3000"
        indicators
      >
        <b-carousel-slide
          aria-label="第一张幻灯片"
          v-for="item in indexData.banners"
          :key="item.id"
        >
          <template v-slot:img>
            <div class="carousel-slide-wrapper">
              <template v-if="isVideo(item.img)">
                <video
                  class="d-block w-100 carousel-video"
                  autoplay
                  muted
                  loop
                >
                  <source :src="item.img" type="video/mp4" />
                </video>
              </template>
              <template v-else>
                <img
                  class="d-block w-100 h-100"
                  :src="item.img"
                  alt=""
                />
              </template>

              <div class="slide-content-row">
                <div class="home-section-inner">
                  <div class="slide-content-inner">
                    <div
                      class="tw-text-textMain slide-name tw-font-bold slide-animate"
                    >
                      <span
                        v-for="(part, partIndex) in getTitleParts(item)"
                        :key="`${item.id || 'banner'}-${partIndex}`"
                      >
                        <br v-if="part.lineBreakBefore" />
                        <span
                          :class="{ 'banner-title-highlight': part.highlight }"
                          :style="part.highlight ? getHighlightStyle(item) : null"
                        >
                          {{ part.text }}
                        </span>
                      </span>
                    </div>
                    <p
                      class="slide-desc tw-text-textLight tw-text-lg slide-animate"
                    >
                      {{ item.desc }}
                    </p>
                    <div class="slide-buttons slide-animate">
                      <button class="btn-consult" @click.stop="handleConsult">
                        <span>立即咨询</span>
                        <img
                          src="@/assets/home/Frame_white.png"
                          alt=""
                          class="btn-icon"
                        />
                      </button>
                      <button class="btn-detail" @click.stop="handleDetail(item)">
                        <span>了解详情</span>
                        <img
                          src="@/assets/home/arrow_right.png"
                          alt=""
                          class="btn-icon"
                        />
                      </button>
                    </div>
                    
                    <div class="carousel-indicators-custom">
                      <div
                        v-for="(banner, index) in indexData.banners"
                        :key="index"
                        class="indicator-dot"
                        :class="{ active: slide === index }"
                        @click.stop="handleClick(banner, index)"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>

              
              <!-- <div
                class="carousel-cont tw-flex tw-justify-center tw-items-center tw-gap-16"
              >
                <div
                  v-for="(tabItem, index) in tabs"
                  :key="index"
                  class="tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-64 tw-cursor-pointer hover:tw-bg-white tw-transition tw-duration-300 tw-ease-in-out"
                  @click.stop="handlePath(tabItem)"
                >
                  <h3 class="tw-font-bold tw-text-lg tw-text-textMain">
                    {{ tabItem.name }}
                  </h3>
                  <p class="tw-text-sm tw-mb-0 tw-text-textLight">
                    {{ tabItem.desc }}
                  </p>
                </div>
              </div> -->
            </div>
          </template>
        </b-carousel-slide>
      </b-carousel>
    </template>
    <!-- 移动端 -->
    <template v-else>
      <div class="phone-carousel ">
        <b-carousel
          v-if="indexData && indexData.banners"
          id="carousel-1"
          ref="myCarousel"
          v-model="slide"
          :interval="3000"
          indicators
        >
          <b-carousel-slide
            aria-label="第一张幻灯片"
            v-for="item in indexData.banners"
            :key="item.id"
            img-height="auto"
          >
            <template v-slot:img>
              <div class="phone-carousel-slide-wrapper mobile">
                <img
                  class="d-block w-100"
                  :src="item.mobilePhoneImg"
                  alt=""
                />

                <b-row class="phone-slide-content-row mobile tw-px-4">
                  <b-col cols="12">
                    <div class="phone-slide-content-inner mobile">
                      <div class="phone-slide-title2">
                        <h5 class="tw-text-textMain phone-slide-title tw-font-bold">
                          <span
                            v-for="(part, partIndex) in getTitleParts(item)"
                            :key="`${item.id || 'mobile-banner'}-${partIndex}`"
                          >
                            <br v-if="part.lineBreakBefore" />
                            <span
                              :class="{ 'banner-title-highlight': part.highlight }"
                              :style="part.highlight ? getHighlightStyle(item) : null"
                            >
                              {{ part.text }}
                            </span>
                          </span>
                        </h5>
                        <p
                          class="phone-slide-desc tw-text-textLight tw-text-xs"
                        >
                          {{ item.desc }}
                        </p>
                      </div>
                      <div class="phone-slide-buttons">
                        <button class="btn-consult" @click.stop="handleConsult">
                          <span>立即咨询</span>
                          <img
                            src="@/assets/home/Frame_white.png"
                            alt=""
                            class="btn-icon"
                          />
                        </button>
                        <button class="btn-detail" @click.stop="handleDetail(item)">
                          <span>了解详情</span>
                        </button>
                      </div>
                      <div class="carousel-indicators-custom">
                        <div
                          v-for="(banner, index) in indexData.banners"
                          :key="index"
                          class="indicator-dot"
                          :class="{ active: slide === index }"
                          @click.stop="handleClick(banner, index)"
                        ></div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-carousel-slide>
        </b-carousel>


        
        <!-- <div
          class="tw-bg-bgMain tw-mt-4 tw-px-4 tw-grid tw-grid-cols-2 tw-items-center tw-gap-4"
        >
          <div
            v-for="(item, index) in tabs"
            :key="index"
            class="tw-h-full tw-bg-white tw-rounded-lg tw-py-5 tw-flex tw-flex-col tw-justify-center tw-items-center"
            @click.stop="handlePath(item)"
          >
            <h4 class="tw-font-bold tw-text-base tw-text-textMain">
              {{ item.name }}
            </h4>
            <p class="tw-text-sm tw-mb-0 tw-text-textLight">
              {{ item.desc }}
            </p>
          </div>
        </div> -->
      </div>
    </template>
  </div>
</template>

<script>
import authMixin from "@/mixins/authMixin";
export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      carouselList: [],
      videoElements: new Map(),
      tabs: [
        {
          name: this.$t("云服务"),
          desc: this.$t("智能发现，一键部署"),
          path: "/cloud",
          id: 1,
        },
        {
          name: this.$t("最新动态"),
          desc: this.$t("掌握公司前沿技术发布"),
          path: "/dynamics",
          id: 2,
        },
        {
          name: this.$t("个人空间"),
          desc: this.$t("专属企业资源与工具"),
          path: "/controlCenter/personal-setting",
          id: 3,
        },
        {
          name: this.$t("活动"),
          desc: this.$t("汇聚研讨，一览俱全"),
          path: "/activity",
          id: 4,
        },
      ],
    };
  },
  computed: {
    indexData() {
      return this.$store.state.indexInfo;
    },
  },
  created() {},
  mixins: [authMixin],
  methods: {
    isVideo(src) {
      if (!src) return false;
      return src.toLowerCase().endsWith(".mp4");
    },

    getTitleParts(item) {
      const title = item?.name || "";
      const highlightText = item?.highlightText || "";
      const titleLines = title.split(/\r?\n|\|/);

      return titleLines.flatMap((line, lineIndex) => {
        const parts = this.getTitleLineParts(line, highlightText);
        return parts.map((part, partIndex) => ({
          ...part,
          // 轮播标题支持后台用“|”或回车指定断行，同时不影响高亮词拆分。
          lineBreakBefore: lineIndex > 0 && partIndex === 0,
        }));
      });
    },

    getTitleLineParts(line, highlightText) {
      if (!line || !highlightText) {
        return line ? [{ text: line, highlight: false }] : [];
      }

      const index = line.indexOf(highlightText);
      if (index === -1) {
        return [{ text: line, highlight: false }];
      }

      return [
        { text: line.slice(0, index), highlight: false },
        { text: highlightText, highlight: true },
        {
          text: line.slice(index + highlightText.length),
          highlight: false,
        },
      ].filter((part) => part.text);
    },

    getHighlightStyle(item) {
      const color = item?.highlightColor || "#4077F8";
      return {
        color: /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(color)
          ? color
          : "#4077F8",
      };
    },

    handleLink(item) {
      window.open(item.url, "_blank");
    },

    handleConsult() {
      if (this.$screen.md) {
        window.kuaizhichat();
      } else {
        window.kuaizhiMobileChat();
      }
    },

    handleDetail(item) {
      if (item.url) {
        window.open(item.url, "_blank");
      }
    },

    handleClick(item, index) {
      this.$refs.myCarousel.setSlide(index);
    },

    prev() {
      this.$refs.myCarousel.prev();
    },

    next() {
      this.$refs.myCarousel.next();
    },

    handlePath(item) {
      const { id, path } = item;
      if (id === 3) {
        if (!this.checkLoginAndRedirect()) return;
      }
      if (path === "/activity") {
        localStorage.setItem("redirectUrl", "/activity");
      }
      this.$router.push(path);
    },
  },
};
</script>
<style lang="scss" scoped>
.carousel-box {
  position: absolute;
  bottom: 20%;
  left: 15%;
  display: flex;
  flex-direction: column;

  .carousel-box_list {
    margin-right: 10px;
    cursor: pointer;
    width: 40px;
    height: 6px;
    z-index: 999;
    border: 1px solid #fff;
    border-radius: 3px;
  }

  .carousel-box_list-show {
    background: #fff;
  }
  .carousel-button {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 999;
  }
}

::v-deep .carousel-indicators {
  display: none !important;
}

.carousel-slide-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background: #e0e8f5;
  
  &.mobile {
    height: auto;
  }
  
  img, video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}

.slide-content-row {
  position: absolute;
  bottom: 20%;
  left: 0;
  right: 0;
  color: #fff;
  margin: 0;
  
  &.mobile {
    bottom: 16%;
  }
}

.slide-content-inner {
  &.mobile {
    padding: 0 16px;
  }
}

.slide-name {
  font-size: 54px;
}
.banner-title-highlight {
  font-weight: inherit;
}
.slide-title {
  max-width: 600px;
}
.slide-title2 {
  width: 200px;
}
.slide-desc {
  width: 50%;
  min-height: 100px;
  margin-top: 20px;
}
.slide-desc2 {
  min-height: 60px;
}

.slide-buttons {
  display: flex;
  gap: 16px;
  margin-top: 20px;
}

.btn-consult,
.btn-detail {
  width: 152px;
  height: 48px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 500;
  border: none;
  outline: none;
  
  .btn-icon {
    width: 16px;
    height: 16px;
  }
}

.btn-consult {
  background: linear-gradient(90deg, #4077F8 0%, #3D4BDF 100%);
  color: #FFFFFF;
  
  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }
}

.btn-detail {
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid #4077F8;
  color: #4077F8;
  
  &:hover {
    background: rgba(255, 255, 255, 0.5);
    transform: translateY(-2px);
  }
}

.carousel-indicators-custom {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  margin-top: 40px;
}

.indicator-dot {
  width: 40px;
  height: 4px;
  background-color: #0000001A;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &.active {
    background-color: #4077F8;
    width: 40px;
    border-radius: 4px;
  }
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.8);
  }
}

::v-deep .carousel-inner {
}
.slide-animate {
  opacity: 0;
  transform: translateY(50px);
  animation: slideUp 0.8s ease-out forwards;
}

.slide-animate:nth-child(1) {
  animation-delay: 0.3s;
}

.slide-animate:nth-child(2) {
  animation-delay: 0.6s;
}

.slide-animate:nth-child(3) {
  animation-delay: 0.9s;
}
.carousel-cont {
  backdrop-filter: blur(20px);
  background: hsla(0, 0%, 94%, 0.7);
  bottom: 0;
  height: 88px;
  position: absolute;
  width: 100%;
  z-index: 39;
}

@keyframes slideUp {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (min-width: 1381px) and (max-width: 1700px) {
  .slide-name {
    font-size: 42px;
  }

  .slide-desc {
    margin-top: 16px;
    font-size: 16px;
    line-height: 1.7;
  }
}

@media (max-width: 1380px) {
  .slide-content-row {
    bottom: 16%;
  }
  .slide-desc {
    min-height: 60px;
    margin-top: 10px;
    font-size: 14px;
  }
  .slide-name {
    font-size: 24px;
  }
  .slide-buttons {
    gap: 12px;
  }
  .btn-consult,
  .btn-detail {
    width: 130px;
    height: 42px;
    font-size: 14px;
    
    .btn-icon {
      width: 14px;
      height: 14px;
    }
  }
  .carousel-indicators-custom {
    margin-top: 28px;
  }
  .carousel-cont {
    height: 60px;
    p {
      font-size: 12px;
    }
    h3 {
      font-size: 14px;
      margin-bottom: 0px;
    }
  }
}

@media (max-width: 768px) {
  ::v-deep .carousel-indicators {
    bottom: 10px;
    margin-bottom: 0;
  }
}


.phone-carousel {
  .phone-slide-content-inner {
    bottom: 0;
    margin: 12px 0 20px;
    .phone-slide-title {
      margin-top: 16xp;
      font-size: 20px;
      color: #111111;
      line-height: 28px;
    }
    .phone-slide-desc {
      line-height: 20px;
    }
    .phone-slide-buttons {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      .btn-consult {
        width: 60%;
      }
      .btn-detail {
        width: 38%;
      }
    }
    .carousel-indicators-custom {
      display: flex;
      flex-direction: row;
      justify-content: center;
      .indicator-dot {
        width: 20px;
        height: 4px;
        background-color: #0000001A;
        cursor: pointer;
        transition: all 0.3s ease;
        &.active {
          background-color: #4077F8;
          width: 20px;
          border-radius: 4px;
        }
      }
    }
  }
  ::v-deep .carousel-inner {
  }.slide-animate {
    opacity: 0;
    transform: translateY(50px);
    animation: null;
  }

  .slide-animate:nth-child(1) {
    animation-delay: 0.3s;
  }

  .slide-animate:nth-child(2) {
    animation-delay: 0.6s;
  }

  .slide-animate:nth-child(3) {
    animation-delay: 0.9s;
  }
  .carousel-cont {
    backdrop-filter: blur(20px);
    background: hsla(0, 0%, 94%, 0.7);
    bottom: 0;
    height: 88px;
    position: absolute;
    width: 100%;
    z-index: 39;
  }
}
</style>
